import { PlaneBufferGeometry, TextureLoader, Vector2 } from "three";
import * as THREE from "three";
import { data, atlasIndexes } from './gameData';
import { Item, Monster, Pet, PetN } from './gameElements';
import gsap from 'gsap';
import { InputItem } from "./gizmo";
export class BackGround extends THREE.Object3D {
    private bgTestGeometry!: PlaneBufferGeometry;
    private bgTexture!: THREE.Texture;
    private testBG!: THREE.Mesh;

    constructor(private targetWidth: number, private targetHeight: number, urlBG: string) {
        super();

        this.bgTexture = new THREE.TextureLoader().load(urlBG, (texture) => {
            const material = new THREE.MeshBasicMaterial({ transparent: true, opacity: 0 });
            material.map = texture;
            this.bgTestGeometry = new THREE.PlaneBufferGeometry(this.targetWidth, this.targetHeight);
            //const material = new THREE.MeshBasicMaterial({ map: this.bgTexture });
            //this.bgTexture.wrapS = this.bgTexture.wrapT = THREE.RepeatWrapping;
            //this.bgTexture.repeat.set(1, 1);

            this.testBG = new THREE.Mesh(this.bgTestGeometry, material);
            this.testBG.renderOrder = -2;
            this.add(this.testBG);
            gsap.to(material, 0.3, { opacity: 1 });
        });
    }
    public InitOffsetY() {
        this.bgTexture?.offset.setY(0);
    }
    public SetOffsetY(val: number): void {
        //this.bgTexture?.offset.setY(this.bgTexture.offset.y + val);
    }
}

export class Man extends THREE.Object3D {
    private bgTestGeometry!: PlaneBufferGeometry;
    private bgTexture!: THREE.Texture;
    private testBG!: THREE.Mesh;
    private testMBG!: THREE.MeshBasicMaterial;

    private bgTestGeometryL!: PlaneBufferGeometry;
    private bgTextureL!: THREE.Texture;
    private testBGL!: THREE.Mesh;
    private testMBGL!: THREE.MeshBasicMaterial;

    private bgTestGeometryR!: PlaneBufferGeometry;
    private bgTextureR!: THREE.Texture;
    private testBGR!: THREE.Mesh;
    private testMBGR!: THREE.MeshBasicMaterial;

    constructor(private targetWidth: number, private targetHeight: number, private TL: TextureManger, private TM: TextureManger, private TR: TextureManger) {
        super();
        //this.bgTexture = new THREE.TextureLoader().load(urlM, (texture) => {
        //this.testMBG = new THREE.MeshBasicMaterial({ transparent: true, opacity: 1 });
        //this.testMBG.map = texture;
        this.bgTestGeometry = new THREE.PlaneBufferGeometry(this.targetWidth, this.targetHeight * 0.85);
        this.TM.GetMaterial().opacity = 1;
        this.testBG = new THREE.Mesh(this.bgTestGeometry, this.TM.GetMaterial());
        this.testBG.renderOrder = -2;
        this.testBG.position.setY(-this.targetHeight * 0.15);
        this.add(this.testBG);

        //});

        //this.bgTextureL = new THREE.TextureLoader().load(urlL, (texture) => {
        //this.testMBGL = new THREE.MeshBasicMaterial({ transparent: true, opacity: 0 });
        //this.testMBGL.map = texture;
        this.bgTestGeometryL = new THREE.PlaneBufferGeometry(this.targetWidth, this.targetHeight * 0.85);
        this.TL.GetMaterial().opacity = 0;

        this.testBGL = new THREE.Mesh(this.bgTestGeometryL, this.TL.GetMaterial());
        this.testBGL.renderOrder = -2;
        this.testBGL.position.setY(-this.targetHeight * 0.15);

        this.add(this.testBGL);

        //});

        //this.bgTextureR = new THREE.TextureLoader().load(urlR, (texture) => {
        //this.testMBGR = new THREE.MeshBasicMaterial({ transparent: true, opacity: 0 });
        //this.testMBGR.map = texture;
        this.bgTestGeometryR = new THREE.PlaneBufferGeometry(this.targetWidth, this.targetHeight * 0.85);
        this.TR.GetMaterial().opacity = 0;

        this.testBGR = new THREE.Mesh(this.bgTestGeometryR, this.TR.GetMaterial());
        this.testBGR.renderOrder = -2;
        this.testBGR.position.setY(-this.targetHeight * 0.15);

        this.add(this.testBGR);
        //this.testBGR.visible = false;

        //});

    }
    private loadTexture(url: string) {
        return new Promise(resolve => {
            new THREE.TextureLoader().load(url, resolve);
        });
    }
    private timeoutIdx = -1;
    public show(idx: number) {
        clearTimeout(this.timeoutIdx);
        this.TR.GetMaterial().opacity = 0;
        this.TM.GetMaterial().opacity = 0;
        this.TL.GetMaterial().opacity = 0;
        if (idx === 0) {
            this.TL.GetMaterial().opacity = 1;
            this.TL.GetMaterial().needsUpdate = true;
            this.timeoutIdx = setTimeout(() => { this.show(1); }, 800);
        } else if (idx === 1) {
            this.TM.GetMaterial().opacity = 1;
            this.TM.GetMaterial().needsUpdate = true;
        } else {
            this.TR.GetMaterial().opacity = 1;
            this.TR.GetMaterial().needsUpdate = true;
            this.timeoutIdx = setTimeout(() => { this.show(1); }, 800);
        }
    }
}

export enum MonsterStatus {
    NONE,
    INIT,
    DETECT,
    PREACTION,
    ACTION,
    HIT
}

export class TextureManger {
    private texture!: THREE.Texture;
    private material!: THREE.MeshBasicMaterial;
    constructor() {

    }
    public InitTexture(urlTexture: string, callback: () => void) {
        this.texture = new THREE.TextureLoader().load(urlTexture, (texture) => { callback();});
        this.material = new THREE.MeshBasicMaterial({ map: this.texture });
        this.material.transparent = true;
    }
    public GetTexture() {
        return this.texture;
    }
    public GetMaterial() {
        return this.material;
    }
}

export enum MonsterType {
    NONE,
    COW,
    CAT,
    FROG,
    TREE,
    BIRD,
    HUMAN,
    ITEM,
    PET,
    PETN
};
export class Board extends THREE.Object3D {
    public OnSound!: (val: string) => void;
    public OnBubbleShow!: () => void;
    public OnBlobEvent!: (type: number) => void;
    public OnUserAction!: (type: number) => void;
    private atlasIndexes: Array<Array<number[][]>> = atlasIndexes;
    private data: string[][] = data;
    public isDemo: boolean = false;
    private bg!: BackGround;
    public man!: Man;
    private currentPosY: number = this.targetHeight * 0.5;
    private guideLineMaterial = new THREE.LineBasicMaterial({ color: 0xCCCCCC });
    private guideLineGeometry = new THREE.BufferGeometry();
    public line = new THREE.Line(this.guideLineGeometry, this.guideLineMaterial);
    private textureManager: TextureManger = new TextureManger();
    private textureManagerPL: TextureManger = new TextureManger();
    private textureManagerPM: TextureManger = new TextureManger();
    private textureManagerPS: TextureManger = new TextureManger();
    private textureManagerItem: TextureManger = new TextureManger();
    private textureManagerManL: TextureManger = new TextureManger();
    private textureManagerManM: TextureManger = new TextureManger();
    private textureManagerManR: TextureManger = new TextureManger();
    private monsters = new Array<Monster>();
    public monstersStack = new Array<Monster>();
    private items = new Array<Monster>();
    public isDebug: boolean = false;

    constructor(private targetWidth: number, private targetHeight: number) {
        super();
        this.bg = new BackGround(this.targetWidth, this.targetHeight, '/assets/onp/bg.jpg');
        this.textureManagerManL.InitTexture('/assets/onp/oldman_ingame_left.png', this.InitMan.bind(this));
        this.textureManagerManM.InitTexture('/assets/onp/2-front.png', this.InitMan.bind(this));
        this.textureManagerManR.InitTexture('/assets/onp/oldman_ingame_right.png', this.InitMan.bind(this));
        this.textureManager.InitTexture('/assets/onp/PET-1024.png', () => { });
        this.textureManagerPL.InitTexture('/assets/onp/Trash(L)-1024.png', () => { });
        this.textureManagerPM.InitTexture('/assets/onp/Trash(M)-1024.png', () => { });
        this.textureManagerPS.InitTexture('/assets/onp/Trash(S)-1024.png', () => { });
        this.textureManagerItem.InitTexture('/assets/onp/item.png', () => { });

        this.add(this.bg);


        
    }
    private loadCnt = 0;
    private InitMan() {
        this.loadCnt++;
        if (this.loadCnt > 2) {
            console.log("@#####")
            this.man = new Man(this.targetWidth, this.targetHeight, this.textureManagerManL, this.textureManagerManM, this.textureManagerManR);
            this.add(this.man);
        }
    }
    private currentIdx = -1;
    private blobCenter: THREE.Vector2 = new THREE.Vector2();
    public CheckCollider(points: THREE.Vector2[], center: THREE.Vector2) {
        this.blobCenter = center;
        for (const item of this.monsters) {
            if (item.HitTest(points)) {
                //center
                item.targetPosition = center;
            }
        }
    }
    public HitTest(points: THREE.Vector2[]) {
        /*for (let i = 0; i < points.length; i++) {
            for (const item of this.monsters) {
                if (!(item instanceof Human) && item.isEnabled && item.status != MonsterStatus.HIT && item.colliderSize > points[i].distanceTo(new Vector2(item.position.x, item.position.y))) {
                    item.SetStatus(MonsterStatus.HIT);
                    return true;
                }
            }
        }*/
        return false;
    }
    private IsIn(target: number, checkVal: Number) {
        return (checkVal >= -target * 0.5 && checkVal <= target * 0.5)
    }
    private compareObjects(obj1: number, obj2: number) {

        if (obj1 < obj2) {
            return -1
        }
        if (obj1 > obj2) {
            return 1
        }
        return 0
    }

    public RemoveAll() {
        this.bg.InitOffsetY();
        this.currentIdx = -1;
        this.currentPosY = this.targetHeight * 0.5;
        let i = this.items.length;
        while (i--) {
            const item = this.items[i];

            //todo add item effect

            this.remove(item!);

            item!.Dispose();
            this.items.splice(i, 1);

        }
        i = this.monsters.length;
        while (i--) {
            const item = this.monsters[i];
            this.remove(item!);
            item!.Dispose();
            this.monsters.splice(i, 1);
        }

        i = this.monstersStack.length;
        while (i--) {
            const item = this.monstersStack[i];
            this.remove(item!);
            item!.Dispose();
            this.monstersStack.splice(i, 1);
        }
    }
    private getRandomInt(min: number, max: number) {
        let range = max + 1 - min;
        return Math.floor(Math.random() * Math.floor(range)) + min;
    }
    public RemoveLine() {
        this.OnSound("item");
        var i = this.monstersStack.length;
        var cnt = 0;
        while (i--) {

            const item = this.monstersStack[i];
            this.remove(item!);
            item!.Dispose();
            this.monstersStack.splice(i, 1);
            cnt++;
            if (cnt > 6) {
                break;
            }
        }
    }
    public StackItem() {
        if (this.isDemo) return;
        //this.monstersStack
        const item = new Pet();
        //item.OnSound = this.OnSound;
        //item.isDebug = this.isDebug;
        var i = this.monstersStack.length;
        item.InitTexture(this.textureManager.GetMaterial(), 7, this.getRandomInt(0, 18), 1.5);
        item.init(i % 9 * 2 - this.targetWidth * 0.5, Math.floor(i / 9) * 4 - this.targetHeight * 0.5);
        item.SetDirection(Math.random() < 0.5 ? true : false);
        this.add(item);
        item.SetRenderOrder(10);
        this.monstersStack.push(item);
    }
    public AddYOffset(val: number) {


        var i = this.monsters.length;
        let renderOrder = 0;
        while (i--) {
            const item = this.monsters[i];
            /*if (!(item instanceof Bird)) {
                item.SetRenderOrder(renderOrder);
                renderOrder++;
            }*/
            item.AddYOffset(val * this.targetHeight);
            if (!this.IsIn(this.targetWidth, item.position.x) || !this.IsIn(this.targetHeight, item.position.y)) {
                if (item.status == 5) {
                    if (item instanceof Pet) {
                        this.OnUserAction(1);

                    } else if (item instanceof PetN) {
                        this.OnUserAction(2);
                    }

                } else if (item.status == 1) {
                    if (item instanceof Pet) {
                        this.OnUserAction(3);
                    }
                }
                this.remove(item!);
                item!.Dispose();
                this.monsters.splice(i, 1);
            }
        }
        this.currentPosY -= val * this.targetHeight;
        const newIdx = Math.floor(this.targetHeight * 0.5 - this.currentPosY);
        if (newIdx > this.currentIdx) {
            for (let i = this.currentIdx; i < newIdx; i++) {
                this.addObject(i + 1, this.targetHeight * 0.5 - (newIdx - i - 1));
                //this.removeObject(i + 1 - this.targetHeight);
            }
        } else if (newIdx < this.currentIdx) {
            for (let i = newIdx; i < this.currentIdx; i++) {
                this.addObject(i + 1 - this.targetHeight, -this.targetHeight * 0.5 + i - newIdx);
                //this.removeObject(i + 1);
            }
        }
        this.currentIdx = newIdx;
        const points = [];
        points.push(new THREE.Vector3(-1000, this.currentPosY, 0));
        points.push(new THREE.Vector3(1000, this.currentPosY, 0));

        this.guideLineGeometry.setFromPoints(points);
        this.guideLineGeometry.attributes.position.needsUpdate = true;
    }
    private itemTempPos: THREE.Vector3 = new THREE.Vector3();

    public HitTestMonsters(id: InputItem, x: number, y: number): void {
        // check if monster hit
        // assign if it is not
        // move if it is assigned


        const point = new THREE.Vector2(x, y);
        for (const item of this.monsters) {
            item.mesh.getWorldPosition(this.itemTempPos);
            if (item.isEnabled && item.status != MonsterStatus.HIT && item.colliderSize > point.distanceTo(new Vector2(this.itemTempPos.x, this.itemTempPos.y))) {
                if (item instanceof Item) {
                    item.visible = false;
                    this.RemoveLine();
                    return;
                }
                item.SetStatus(MonsterStatus.HIT);
                id.monster = item;
                item.IsGrab = true;
                item.SetRenderOrder(1000);
                item.scale.set(1.5, 1.5, 1);
                return;
            }
        }
    }
    public HitTestItems(x: number, y: number) {
        const point = new THREE.Vector2(x, y);
        for (const item of this.items) {
            item.mesh.getWorldPosition(this.itemTempPos);
            if (item.isEnabled && item.status != MonsterStatus.HIT && item.colliderSize > point.distanceTo(new Vector2(this.itemTempPos.x, this.itemTempPos.y))) {
                item.SetStatus(MonsterStatus.HIT);
                return true;
            }
        }
        return false;
    }
    private addObject(idx: number, rowIdx: number) {
        /// todo ONP set random items here
        if (idx >= 0 && idx % 5 == 0) {
            for (let i = 1; i < 4; i++) {
                if (Math.random() < 0.22) {
                    var r = Math.random();
                    if (r < 0.5) {
                        const item = new Pet();
                        item.OnSound = this.OnSound;
                        item.isDebug = this.isDebug;
                        item.InitTexture(this.textureManager.GetMaterial(), 7, this.getRandomInt(0, 18), 1);
                        item.init(i * 3 - this.targetWidth * 0.5, rowIdx);
                        item.SetDirection(Math.random() < 0.5 ? true : false);
                        this.add(item);
                        this.monsters.push(item);
                        item.SetRenderOrder(500);
                    } else if (r < 0.52) {
                        const item = new Item();
                        item.OnSound = this.OnSound;
                        item.isDebug = this.isDebug;
                        item.InitTexture(this.textureManagerItem.GetMaterial(), 1, 0, 1);
                        item.init(i * 3 - this.targetWidth * 0.5, rowIdx);
                        item.SetDirection(Math.random() < 0.5 ? true : false);
                        this.add(item);
                        this.monsters.push(item);
                        item.SetRenderOrder(500);

                    } else {
                        let size = 0;
                        let sx = 5.2;
                        let s = 4.7;
                        const r = Math.random();
                        if (r < 0.33) {
                            size = 1;
                            sx = 4.2;
                            s = 3.5;
                        } else if (r < 0.66) {
                            size = 2;
                            sx = 3.5;
                            s = 2.3;
                        }


                        const item = new PetN(sx, sx, sx);
                        item.OnSound = this.OnSound;
                        item.isDebug = this.isDebug;
                        if (size == 0) {
                            item.InitTexture(this.textureManagerPL.GetMaterial(), 7, this.getRandomInt(0, 15), 1);
                        } else if (size == 1) {
                            item.InitTexture(this.textureManagerPM.GetMaterial(), 7, this.getRandomInt(0, 26), 0.8);
                        } else { item.InitTexture(this.textureManagerPS.GetMaterial(), 7, this.getRandomInt(0, 48), 0.6); }
                        item.init(i * 3 - this.targetWidth * 0.5, rowIdx);
                        item.SetDirection(Math.random() < 0.5 ? true : false);
                        this.add(item);
                        this.monsters.push(item);
                        item.SetRenderOrder(500);

                    }

                }
            }
            //console.log("addObject:" + idx % this.data.length + ":" + rowIdx);
            /*for (let i = 0; i < this.data[idx % this.data.length].length; i++) {
                var dataInfoArr = this.data[idx % this.data.length][i].split(".");
                if (parseInt(dataInfoArr[0]) < 7) {
                    switch (parseInt(dataInfoArr[0]) as MonsterType) {
                        case MonsterType.COW:
                            const cow = new Cow();
                            cow.OnSound = this.OnSound;
                            cow.isDebug = this.isDebug;
                            cow.InitTexture(this.textureManager.GetMaterial(), 9, this.atlasIndexes[MonsterType.COW][parseInt(dataInfoArr[1])], 1.5);
                            cow.init(i - this.targetWidth * 0.5, rowIdx);
                            cow.SetDirection(Math.random() < 0.5 ? true : false);
                            this.add(cow);
                            this.monsters.push(cow);
                            break;
                        case MonsterType.CAT:
                            const cat = new Cat();
                            cat.OnSound = this.OnSound;

                            cat.isDebug = this.isDebug;
                            cat.InitTexture(this.textureManager.GetMaterial(), 9, this.atlasIndexes[MonsterType.CAT][parseInt(dataInfoArr[1])], 1.8);
                            cat.init(i - this.targetWidth * 0.5, rowIdx);
                            cat.SetDirection(Math.random() < 0.5 ? true : false);
                            cat.callBack = () => {
                                return this.blobCenter;
                            };
                            this.add(cat);
                            this.monsters.push(cat);
                            break;
                        case MonsterType.FROG:
                            const frog = new Frog();
                            frog.OnSound = this.OnSound;

                            frog.isDebug = this.isDebug;
                            frog.InitTexture(this.textureManager.GetMaterial(), 9, this.atlasIndexes[MonsterType.FROG][parseInt(dataInfoArr[1])], 2.2);
                            frog.SetDirection(Math.random() < 0.5 ? true : false);
                            frog.init(i - this.targetWidth * 0.5, rowIdx);
                            this.add(frog);
                            this.monsters.push(frog);
                            break;
                        case MonsterType.TREE:
                            const tree = new Tree();
                            tree.OnSound = this.OnSound;

                            tree.isDebug = this.isDebug;
                            tree.InitTexture(this.textureManagerTree.GetMaterial(), 5, this.atlasIndexes[MonsterType.TREE][parseInt(dataInfoArr[1])], 4);
                            tree.init(i - this.targetWidth * 0.5, rowIdx);
                            this.add(tree);
                            this.monsters.push(tree);
                            break;
                        case MonsterType.BIRD:
                            const bird = new Bird();
                            bird.OnSound = this.OnSound;
                            bird.isDebug = this.isDebug;
                            bird.InitTexture(this.textureManager.GetMaterial(), 9, this.atlasIndexes[MonsterType.BIRD][parseInt(dataInfoArr[1])], 2);
                            bird.SetDirection(Math.random() < 0.5 ? true : false);

                            let sx = -9;
                            let dx = 9;
                            if (i != 0) {
                                sx = 8;
                                dx = -9;
                            }
                            bird.init(sx, parseInt(dataInfoArr[2]), dx, parseInt(dataInfoArr[3]));
                            bird.SetRenderOrder(100);
                            this.add(bird);
                            this.monsters.push(bird);
                            break;
                        case MonsterType.HUMAN:
                            const human = new Human();
                            human.OnSound = this.OnSound;

                            human.InitTexture(this.textureManager.GetMaterial(), 9, this.atlasIndexes[MonsterType.HUMAN][parseInt(dataInfoArr[1])], 1.3);
                            human.init(i - this.targetWidth * 0.5, rowIdx);
                            human.SetDirection(Math.random() < 0.5 ? true : false);
                            if (!this.isDemo) {
                                human.OnBubbleShow = this.OnBubbleShow;
                            }
                            this.add(human);
                            this.monsters.push(human);
                            break;
                    }
                } else {
                    const item = new Item();
                    item.OnSound = this.OnSound;

                    item.InitTexture(this.textureManagerItem.GetMaterial(), 2, this.atlasIndexes[MonsterType.ITEM][parseInt(dataInfoArr[1])], 1.3);
                    item.init(parseInt(dataInfoArr[1]), parseInt(dataInfoArr[2]));
                    item.SetRenderOrder(9999);
                    //item.SetDirection(Math.random() < 0.5 ? true : false);
                    //item.OnBubbleShow = this.OnBubbleShow;
                    this.add(item);
                    this.items.push(item);
                }
            }*/
        }
    }
}